import { useTranslation } from 'next-i18next';
import React, { ReactElement } from 'react';
import {
  FdrCo2AdditionalInfoWrapper,
  FdrCO2FootprintTitle,
} from './fdr-co2-footprint.styles';

interface IFdrCo2AdditionalInfoProps {
  arrivalDeparture?: string;
  overnightStayAccommodation?: string;
  specialities?: string;
  transportInfo?: string;
  duration?: string;
}

export function FdrCo2AdditionalInfo({
  transportInfo,
  arrivalDeparture,
  overnightStayAccommodation,
  specialities,
  duration,
}: IFdrCo2AdditionalInfoProps): ReactElement {
  const [t] = useTranslation('pdp');

  return (
    <FdrCo2AdditionalInfoWrapper>
      {duration ? (
        <FdrCo2AdditionalInfoItem
          title={t('pdp:co2Footprint.modal.duration')}
          text={duration}
        />
      ) : null}
      {overnightStayAccommodation ? (
        <FdrCo2AdditionalInfoItem
          title={t('pdp:co2Footprint.modal.accommodation')}
          text={overnightStayAccommodation}
        />
      ) : null}
      {arrivalDeparture ? (
        <FdrCo2AdditionalInfoItem
          title={t('pdp:co2Footprint.modal.arrivalDeparture')}
          text={arrivalDeparture}
        />
      ) : null}
      {transportInfo ? (
        <FdrCo2AdditionalInfoItem
          title={t('pdp:co2Footprint.modal.transport')}
          text={transportInfo}
        />
      ) : null}
      {specialities ? (
        <FdrCo2AdditionalInfoItem
          title={t('pdp:co2Footprint.modal.specialities')}
          text={specialities}
        />
      ) : null}
    </FdrCo2AdditionalInfoWrapper>
  );
}

interface IFdrCo2AdditionalInfoItemProps {
  title: string;
  text: string;
}

function FdrCo2AdditionalInfoItem({
  title,
  text,
}: IFdrCo2AdditionalInfoItemProps): ReactElement {
  return (
    <div>
      <FdrCO2FootprintTitle>{title}</FdrCO2FootprintTitle>
      <span dangerouslySetInnerHTML={{ __html: text }} />
    </div>
  );
}
